import * as React from 'react';
import { Breadcrumbs as MUIBreadcrumbs, Typography, Link } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useLocation, useNavigate } from 'react-router';
import './Breadcrumbs.css';
import { useDispatch, useSelector } from 'react-redux';
import { Routing } from '../../utils/Routing';

const Breadcrumbs = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const people = useSelector((state) => state.peopleState);
  const navigate = useNavigate();
  const pathname = location.pathname.split('/').filter((x) => x);

  const getReformatedName = (str) => {
    const reformatedName = str.replace(/%20/g, ' ');
    const words = reformatedName.split('-');
    let result = '';
    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      if (i === 0) {
        result +=
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ' ';
      } else {
        result += word.toLowerCase() + ' ';
      }
    }
    return result.trim();
  };

  const path = location.pathname;
  return (
    <MUIBreadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
      <Link
        color="inherit"
        className="hoverable"
        onClick={() => {
          dispatch({
            type: 'PEOPLE_PAGE',
            data: {
              id: '',
            },
          });
          navigate(Routing(path));
        }}
      >
        <HomeIcon fontSize="small" className="breadcrumb-icon" />
      </Link>
      {pathname.map((name, index) => {
        let displayName = name;
        if (
          name === 'user-work-reports' &&
          location.search.includes('tab=course')
        ) {
          displayName = 'user-course-reports';
        }
        const route = pathname.slice(0, index + 1).join('/');
        return (
          <Link
            color="inherit"
            className="hoverable"
            key={index}
            onClick={() => {
              dispatch({
                type: 'PEOPLE_PAGE',
                data: {
                  id: people.id,
                  display: true,
                },
              });
              navigate(route);
            }}
          >
            {getReformatedName(displayName)}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
